import { Outlet, Link } from "react-router-dom";
import PublicHeader from "@/components/public/PublicHeader";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-worksans flex flex-col">
      <PublicHeader />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <footer className="border-t border-slate-200 bg-white mt-12">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-4">
            <div className="flex items-center gap-2">
              <img src="/wizard-icon.png" alt="dealzauber" className="h-7 w-7 rounded-lg" />
              <span className="font-outfit font-extrabold tracking-tight">
                <span className="text-slate-900">deal</span><span className="ai-gradient-text">zauber</span>
              </span>
            </div>
            <p className="text-xs text-slate-400 font-worksans text-center">
              Die magischsten Deals – von der Community gewählt. © {new Date().getFullYear()} dealzauber.de
            </p>
            <Link to="/admin" className="text-xs text-slate-400 hover:text-slate-600 transition-colors">Admin</Link>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 pt-4 border-t border-slate-100">
            <Link to="/impressum" className="text-xs text-slate-400 hover:text-[#A259FF] transition-colors" data-testid="footer-impressum">Impressum</Link>
            <span className="text-slate-200">|</span>
            <Link to="/datenschutz" className="text-xs text-slate-400 hover:text-[#A259FF] transition-colors" data-testid="footer-datenschutz">Datenschutzerklärung</Link>
            <span className="text-slate-200">|</span>
            <Link to="/agb" className="text-xs text-slate-400 hover:text-[#A259FF] transition-colors" data-testid="footer-agb">AGB</Link>
            <span className="text-slate-200">|</span>
            <a href="mailto:admin@dealzauber.de" className="text-xs text-slate-400 hover:text-[#A259FF] transition-colors" data-testid="footer-contact">Kontakt</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
